let ramp_routes = [
  {
    path: '/',
    component: () => import('Modules/Dashboard/resources/layout/DashboardLayout.vue'),
    children: [
      { path: 'ramps', name: 'ramps.list', component: () => import('./pages/Index.vue') },
      { path: 'ramps/create', name: 'ramps.create', component: () => import('./pages/Create.vue') },
      { path: 'ramps/tiers', name: 'ramp-tiers.list', component: () => './pages/tiers/Index.vue'},
      { path: 'ramps/tiers/create', name: 'ramp-tiers.create', component: () => './pages/tiers/Create.vue'},
      { path: 'ramps/:id/edit', name: 'ramps.edit', component: () => import('./pages/Edit.vue') },
      { path: 'ramps/:ramp_id/tiers/:id/edit', name: 'ramp-tiers.edit', component: () => './pages/tiers/Edit.vue'},
    ]
  }
];

export default ramp_routes;
